module.exports = __webpack_public_path__ + "img/unlock.bb817d95.svg";